import {datadogRum} from "@datadog/browser-rum";
import "services-comun/modules/types";
import config from "./utiles/config";

if (PRODUCCION && !TEST) {
    datadogRum.init({
        applicationId: '94eccf5d-9800-4a7f-b48d-f4c393d3b621',
        clientToken: 'pub7f920f08ee2b38cfc922ea5e813dcb30',
        site: 'datadoghq.eu',
        service: 'tiempo-www/javscript-src',
        env: 'prod',
        version: `${config.dd.version}`,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 10,
        defaultPrivacyLevel: 'mask-user-input',
    });
}

import type {DominioTiempo} from "services-comun-meteored/modules/portal/tiempo";

import {Entry} from "./root/entry";

import(/* webpackChunkName: "site/[request]" */`services-comun-meteored/modules/portal/tiempo/dominios/${config.site}`)
    .then(module=>module.default)
    .then((dominio: DominioTiempo)=>{
        const entry = new Entry(document, config, dominio);

        {
            // Módulos de redacción
            if (config.cfg.news.enabled) {
                entry.add("redaccion/last");
            }
        }
        {
            // Módulos de contacto
            entry.add("contact/work", {
                selector: {
                    some: ["#enviarcv"],
                },
            });
        }
    });
